import getStore from 'services/getStore';

const getModuleImages = () => {
  const interactionBackgrounds = [] as any[];
  const images = [] as string[];

  // will fix this up later
  let blocks_ = getStore().getState().blocks as any; // blocks;

  Object.values(blocks_).forEach((b: any, index: number) => {
    switch (b.type) {
      case 'Interaction': {
        b.type === 'Interaction' &&
          b.props.background &&
          b.props.background.includes('url') &&
          interactionBackgrounds.push(b.props.background.split(/url\(|\)/g)[1]);
        // console.log('Interaction :', b.type);
        break;
      }
      case 'Image': {
        b.props.src && images.push(b.props.src);
        // console.log('Image :', b.type);
        break;
      }
      case 'HotSpotIsolated': {
        b.props.src && images.push(b.props.src);
        // console.log('HotSpotIsolated :', b.type);
        break;
      }
    }
  });

  const allImagesComped: any[] = Array.from(
    new Set([...interactionBackgrounds, ...images])
  );

  console.log('allImagesComped :', allImagesComped);
  // console.log('allImages :', [...interactionBackgrounds, ...images]);

  return allImagesComped;
  // [...interactionBackgrounds, ...images];
};

export default getModuleImages;
